<div class="row">
  <div class="col-lg-12">
    <div class="carousel-component" [style.background-color]="style().leadingColorCode">
      <carousel [interval]="style().slideIntervalInMs">
        @for (slide of model()?.slides; track slide) {
          <slide>
            <div class="row slide-row">
              @if (slide.imageUrl) {
                <div class="col-lg-6 img-box">
                  <img
                    [src]="slide.imageUrl"
                    [alt]="'GAST-PORTAL-NG.CAROUSEL.SLIDE' | translate"
                    style="display: block; width: 100%" />
                </div>
              }
              <div
                [ngClass]="slide.imageUrl ? 'col-lg-6' : 'col-lg-12'"
                [class.right-align]="style().textAlignment === 'right'">
                <div [innerHtml]="slide.slideHtml"></div>
              </div>
            </div>
          </slide>
        }
      </carousel>
    </div>
  </div>
</div>
